import '@progress/kendo-theme-bootstrap/dist/all.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { ThemeProvider } from '@mui/material';
import { theme } from './theme';
import { store } from './store/store';
import { Provider } from 'react-redux';
import CssBaseline from '@mui/material/CssBaseline';

import * as Sentry from '@sentry/react';


const isDeployedBcitHost = /\.bcit\.ca$/i.test(window.location.hostname);

// /login carries the sign-in token (holds the user's BCIT ID) in the query string
const stripQuery = (url?: string) => url?.split('?')[0];

const stripRequestQuery = (request?: { url?: string; headers?: { [key: string]: string } }) => {
    if (!request) return;
    request.url = stripQuery(request.url);
    if (request.headers?.Referer) request.headers.Referer = stripQuery(request.headers.Referer) as string;
};

if (process.env.NODE_ENV === 'production' && isDeployedBcitHost) {
    Sentry.init({
        dsn: 'https://f814015f70284e51abd8fb5abcebe748@o972955.ingest.sentry.io/6463579',
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
        beforeSend(event) {
            if (event.user) {
                delete event.user.email;
                delete event.user.username;
            }
            if (event.request) {
                delete event.request.cookies;
            }
            stripRequestQuery(event.request);
            return event;
        },
        beforeSendTransaction(event) {
            stripRequestQuery(event.request);
            return event;
        },
        beforeBreadcrumb(breadcrumb) {
            if (breadcrumb.category === 'console') return null;
            if (breadcrumb.data?.url?.includes('/Auth/AssertionConsumerService')) return null;
            if (breadcrumb.data?.url) breadcrumb.data.url = stripQuery(breadcrumb.data.url);
            if (breadcrumb.data?.from) breadcrumb.data.from = stripQuery(breadcrumb.data.from);
            if (breadcrumb.data?.to) breadcrumb.data.to = stripQuery(breadcrumb.data.to);
            return breadcrumb;
        },
    });
}

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript


root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Provider store={store}>
                <App />
            </Provider>
        </ThemeProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
